let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("fat9k")]).then(() => parcelRequire('9fBrm'));